module.exports = __webpack_public_path__ + "img/4.7dca0e0a.jpg";